import "babel-polyfill";
import React, { Component } from 'react';
import BaseRoute from './routes/base-route';
import { Provider } from 'react-redux';
import { applicationHistory } from './common/application-history';
import reducers from './common/reducers';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import { connectToHistory } from './common/title-handler';
import './common/style/common.scss';
import { historyEventListener} from "./common/actions/history-actions";

const reactRouterReduxMiddleware = routerMiddleware(applicationHistory);

export const store = createStore(
		reducers,
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({ serialize: true }),
		applyMiddleware(thunk, reactRouterReduxMiddleware)
	);


applicationHistory.listen( (location, action) => store.dispatch(historyEventListener(location,action)))

export default class Application extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	componentDidMount() {
		connectToHistory();
		store.dispatch(historyEventListener(document.location, "PUSH"));

	}

	render() {
		return (
			<Provider store={store}>
				<BaseRoute {...this.props} />
			</Provider>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App.js